import { registerLocaleData } from '@angular/common';
import { APP_INITIALIZER, Injectable, LOCALE_ID } from '@angular/core';
import { loadTranslations } from '@angular/localize';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
  
})

class I18n {

    locale = 'en';
  
  constructor(private cookieService: CookieService) 
  {    
  }

  async setLocale() {

    let userLocale = localStorage.getItem('locale');

    if (this.cookieService.check('lang')) {
      userLocale = this.cookieService.get('lang');
      localStorage.setItem('locale', userLocale);
    }

    // If the user has a preferred language stored in localStorage, use it.
    if (userLocale) {
      this.locale = userLocale;
    }
    if (this.locale !== 'fr') {
        if (this.locale !== 'es') {
             this.locale = 'en';
             localStorage.setItem('locale', this.locale);
        }
    }
    // Use web pack magic string to only include required locale data
    const localeModule = await import(

      `/node_modules/@angular/common/locales/${this.locale}.mjs`

    );

    // Set locale for built in pipes, etc.
    registerLocaleData(localeModule.default);

    // Load translation file
    const localeTranslationsModule = await import(
      `src/assets/i18n/${this.locale}.json`
    );

    // Load translations for the current locale at run-time
    loadTranslations(localeTranslationsModule.default);
  }
}

// Load locale data at app start-up
function setLocale() {
  return {
    provide: APP_INITIALIZER,
    useFactory: (i18n: I18n) => () => i18n.setLocale(),
    deps: [I18n],
    multi: true,
  };
}

// Set the runtime locale for the app
function setLocaleId() {
  return {
    provide: LOCALE_ID,
    useFactory: (i18n: I18n) => i18n.locale,
    deps: [I18n],
  };
}

  
export const I18nModule = {
  setLocale: setLocale,
  setLocaleId: setLocaleId,
};

